import React from 'react'
import { Router } from 'react-router'
import { ApolloProvider } from 'react-apollo'
import createBrowserHistory from 'history/createBrowserHistory'
import PropTypes from 'prop-types'
import _client, { graphqlUri } from './ApolloClient'
import LoginModal from './LoginModal'
import { registerLoginOpener } from './loginGate'

import 'video-react/dist/video-react.css'

const history = createBrowserHistory()

export default class Main extends React.Component {
  static propTypes = {
    routes: PropTypes.any.isRequired,
  }

  state = { loginVisible: false }

  componentDidMount() {
    // 写操作被后端要求登录时，由 ApolloClient 的拦截器触发此处弹框
    registerLoginOpener(({ onSuccess, onCancel }) => {
      this.loginHandlers = { onSuccess, onCancel }
      this.setState({ loginVisible: true })
    })
  }

  closeLogin = () => {
    const { onCancel } = this.loginHandlers || {}
    this.loginHandlers = null
    this.setState({ loginVisible: false })
    onCancel && onCancel()
  }

  handleLoginSuccess = (result) => {
    const { onSuccess } = this.loginHandlers || {}
    this.loginHandlers = null
    this.setState({ loginVisible: false })
    onSuccess && onSuccess(result)
  }

  render() {
    return (
      <ApolloProvider client={_client}>
        <div style={{ height: '100%' }}>
          <Router history={history} children={this.props.routes} />
          <LoginModal
            visible={this.state.loginVisible}
            uri={graphqlUri}
            onClose={this.closeLogin}
            onSuccess={this.handleLoginSuccess}
          />
        </div>
      </ApolloProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/main.js